export enum Environment {
  Production = "production",
  Staging = "staging",
  Development = "development",
  Test = "test",
}

export function isEnv(env: Environment): boolean {
  return (window as any).APP_ENV === env;
}
